/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Alloy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SystemPermission = 'CreateEventTemplates' | 'ViewEventTemplates' | 'EditEventTemplates' | 'ManageEventTemplates' | 'CreateEvents' | 'ViewEvents' | 'EditEvents' | 'ExecuteEvents' | 'ManageEvents' | 'ViewUsers' | 'ManageUsers' | 'ViewRoles' | 'ManageRoles' | 'ViewGroups' | 'ManageGroups';

export const SystemPermission = {
    CreateEventTemplates: 'CreateEventTemplates' as SystemPermission,
    ViewEventTemplates: 'ViewEventTemplates' as SystemPermission,
    EditEventTemplates: 'EditEventTemplates' as SystemPermission,
    ManageEventTemplates: 'ManageEventTemplates' as SystemPermission,
    CreateEvents: 'CreateEvents' as SystemPermission,
    ViewEvents: 'ViewEvents' as SystemPermission,
    EditEvents: 'EditEvents' as SystemPermission,
    ExecuteEvents: 'ExecuteEvents' as SystemPermission,
    ManageEvents: 'ManageEvents' as SystemPermission,
    ViewUsers: 'ViewUsers' as SystemPermission,
    ManageUsers: 'ManageUsers' as SystemPermission,
    ViewRoles: 'ViewRoles' as SystemPermission,
    ManageRoles: 'ManageRoles' as SystemPermission,
    ViewGroups: 'ViewGroups' as SystemPermission,
    ManageGroups: 'ManageGroups' as SystemPermission
};

